import { graphql } from "@/__graphql__";

export default graphql(`
  query Products__ProductsSummary__ProductsSummaryQuery($relationId: ID, $locationId: ID, $condition: [ProductCondition!]) {
    productsSummary(relationId: $relationId, locationId: $locationId, condition: $condition) {
      productType {
        id
        code
        description
        category {
          id
          name
          parent {
            id
            name
          }
        }
      }
    }
  }
`);
